import { worker } from './browser.web'

export async function enableMocking() {
  if (!__DEV__ || process.env.EXPO_PUBLIC_ENABLE_MSW !== 'true') {
    return
  }

  await worker.start({
    onUnhandledRequest: 'bypass',
  })
}
